import 'twin.macro';

import imgBigTime from '../../assets/images/bigtime-logo.png';
import imgShadow from '../../assets/svgs/bigtime-shadow.svg';
import imgShadowMobile from '../../assets/svgs/bigtime-shadow_mobile.svg';
import imgLogos from '../../assets/svgs/logos.svg';
import imgLogosMobile from '../../assets/svgs/logos_mobile.svg';

const HeroSection = () => {
  return (
    <div tw="relative pt-[160.26%] md:pt-[50.7%] w-full flex flex-col bg-hero-mobile md:bg-hero-desktop bg-no-repeat bg-bottom bg-cover">
      <div tw="absolute left-1/2 translate-x-[-50%] top-[12%] md:top-[10%] w-full">
        <div
          css={{
            backgroundImage:
              'linear-gradient(180deg, #FFFFFF 32.41%, #A98FBC 100%)',
          }}
          tw="pb-1 font-lumadFree text-[4.8vw] md:text-[2.6vw] text-center leading-[140%] tracking-normal bg-clip-text text-transparent"
        >
          Joystick's
        </div>
        <div
          css={{
            backgroundImage:
              'linear-gradient(87.69deg, #E13656 22.15%, #A237F5 96.49%)',
          }}
          tw="mx-auto mt-[-3.2vw] md:mt-[-1.6vw] pb-1 w-[fit-content] font-lumadFree text-[7.4vw] md:text-[4vw] text-center leading-[140%] tracking-normal bg-clip-text text-transparent"
        >
          NFT HUNT:
        </div>
        <div tw="relative h-[32vw] md:h-[10vw]">
          <img
            alt="shadow"
            src={imgShadowMobile}
            tw="block md:hidden absolute left-1/2 -top-14 translate-x-[-50%] w-[160%]"
          />
          <img
            alt="shadow"
            src={imgShadow}
            tw="hidden md:block absolute left-1/2 -top-16 translate-x-[-50%] w-[45%]"
          />
          <img
            alt="big time"
            src={imgBigTime}
            tw="absolute left-1/2 top-7 translate-x-[-50%] w-[47%] md:w-[20%]"
          />
        </div>
        <div tw="text-[4vw] md:text-[1.8vw] uppercase text-center">
          Hosted by
        </div>
        <div tw="pt-[6vw] md:pt-[1.8vw] flex justify-center">
          <img
            alt="2 logos"
            src={imgLogosMobile}
            tw="block md:hidden w-full max-w-[30vw]"
          />
          <img
            alt="2 logos"
            src={imgLogos}
            tw="hidden md:block w-full max-w-[30vw]"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
